/* 本地存储 */
export const MARKDOWN_LOCAL_STORAGE = "localMdStorage";